import React from 'react';
import { testimonials } from '../data/mock';
import { Star } from 'lucide-react';

const TestimonialCard = ({ t }) => (
  <div className="gradient-border p-6 w-[280px] md:w-[320px] flex-shrink-0">
    <div className="flex gap-1 mb-3">
      {[...Array(5)].map((_, k) => (
        <Star key={k} className="w-4 h-4 fill-blue-400 text-blue-400" />
      ))}
    </div>
    <p className="text-white/80 text-sm leading-relaxed mb-5">"{t.text}"</p>
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0"
        style={{ background: 'linear-gradient(135deg, #0a46dd, #1a6bff)' }}>
        {t.name[0]}
      </div>
      <div>
        <p className="text-white text-sm font-semibold">{t.name}</p>
        <p className="text-white/50 text-xs">{t.location}</p>
      </div>
    </div>
  </div>
);

const Testimonials = () => {
  const items = [...testimonials, ...testimonials, ...testimonials];
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-8 mb-12">
        <div className="text-center">
          <p className="text-blue-400 text-sm font-semibold uppercase tracking-widest mb-3">Depoimentos</p>
          <h2 className="text-4xl md:text-6xl font-extrabold text-white leading-tight">
            Histórias reais de quem <span className="gradient-text">recuperou a vida</span>
          </h2>
        </div>
      </div>

      {/* Mobile E Desktop: scroll horizontal */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-y-0 left-0 w-16 md:w-32 bg-gradient-to-r from-[#030b1a] to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-16 md:w-32 bg-gradient-to-l from-[#030b1a] to-transparent z-10 pointer-events-none" />
        {/* Mobile: scroll manual */}
        <div className="md:hidden flex gap-4 px-6 overflow-x-auto pb-4 no-scrollbar">
          {testimonials.map((t, i) => <TestimonialCard key={i} t={t} />)}
        </div>
        {/* Desktop: carousel automático */}
        <div className="hidden md:flex gap-5 scroll-marquee w-max">
          {items.map((t, i) => <TestimonialCard key={i} t={t} />)}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
